import { Language } from '../../lang/Language'
import { GameMode, GameModeTag } from './GameMode.types'

export class GameModes {
  public static Default = new GameMode(GameModeTag.default, Language.strings.states.game.default)
  public static Tournament = new GameMode(GameModeTag.tournament, Language.strings.states.game.tournament)
  public static Practice = new GameMode(GameModeTag.practice, Language.strings.states.game.practice)
  public static PracticeTournament = new GameMode(GameModeTag.practiceTournament, Language.strings.states.game.practice)
  public static OpenQuickGame = new GameMode(GameModeTag.openQuickGame, Language.strings.states.game.open)
  public static ThreeCard = new GameMode(GameModeTag.threeCard, Language.strings.states.game.threeCard)

  static isDefault(s: GameMode) {
    const tag = s.tag || s._tag
    return tag === GameModeTag.default
  }

  static isTournament(s: GameMode) {
    const tag = s.tag || s._tag
    return tag === GameModeTag.tournament
  }

  static isPractice(s: GameMode) {
    const tag = s.tag || s._tag
    return tag === GameModeTag.practice
  }

  static isPracticeTournament(s: GameMode) {
    const tag = s.tag || s._tag
    return tag === GameModeTag.practiceTournament
  }

  static isOpenQuickGame(s: GameMode) {
    const tag = s.tag || s._tag
    return tag === GameModeTag.openQuickGame
  }

  static isThreeCard(s: GameMode) {
    const tag = s.tag || s._tag
    return tag === GameModeTag.threeCard
  }

  static returnMode(s: string) {
    if (s === GameModeTag.tournament) return GameModes.Tournament
    if (s === GameModeTag.practice) return GameModes.Practice
    if (s === GameModeTag.practiceTournament) return GameModes.PracticeTournament
    if (s === GameModeTag.openQuickGame) return GameModes.OpenQuickGame
    if (s === GameModeTag.threeCard) return GameModes.ThreeCard
    return GameModes.Default
    // TODO(kaplanski): Should we be handling these errors better?
  }
}
